
import React, { memo } from "react";

const CommunityBackground = () => {
  return (
    <div 
      className="absolute inset-0 z-0 overflow-hidden"
      aria-hidden="true"
      role="presentation"
    >
      {/* Base patterns - using CSS instead of images */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 to-white"></div>
      
      {/* Using CSS patterns instead of heavy image backgrounds */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] [background-size:20px_20px]"></div>
      
      {/* Top gradient */}
      <div className="absolute top-0 inset-x-0 h-40 bg-gradient-to-b from-blue-50 to-transparent opacity-70"></div>
      
      {/* Bottom gradient */}
      <div className="absolute bottom-0 inset-x-0 h-40 bg-gradient-to-t from-emerald-50 to-transparent opacity-70"></div>
      
      {/* Left decoration - using CSS blurs instead of images */}
      <div className="absolute -left-24 top-1/4 w-48 h-48 rounded-full bg-blue-300/10 blur-3xl"></div>
      
      {/* Right decoration */}
      <div className="absolute -right-24 bottom-1/4 w-48 h-48 rounded-full bg-emerald-300/10 blur-3xl"></div>
      
      {/* Subtle dot pattern - using CSS pattern for better performance */}
      <div className="absolute inset-0 bg-[radial-gradient(#e0e7ff_1px,transparent_1px)] [background-size:20px_20px] opacity-30"></div>
    </div>
  );
};

// Memo to prevent unnecessary re-renders
export default memo(CommunityBackground);
export { CommunityBackground };
